import React from 'react';

const FigureNewsIcon = ({ width = 80, height = 80, color = "#5CB85C", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Green circle background */}
      <circle cx="40" cy="40" r="38" fill={color}/>

      {/* Newspaper body */}
      <rect x="20" y="18" width="40" height="44" rx="3" fill="white"/>

      {/* Left fold strip */}
      <rect x="16" y="24" width="7" height="32" rx="2" fill="white"/>
      <rect x="16" y="24" width="7" height="32" rx="2" fill={color} opacity="0.25"/>

      {/* NEWS header bar */}
      <rect x="23" y="22" width="34" height="10" rx="1.5" fill={color}/>
      <text x="40" y="30" textAnchor="middle" fill="white" fontSize="7" fontWeight="bold" fontFamily="Arial, sans-serif">NEWS</text>

      {/* Headline line */}
      <rect x="23" y="36" width="34" height="3" rx="1" fill={color} opacity="0.7"/>

      {/* Body text lines */}
      <rect x="23" y="42" width="22" height="2" rx="1" fill="#ccc"/>
      <rect x="23" y="47" width="34" height="2" rx="1" fill="#ccc"/>
      <rect x="23" y="52" width="28" height="2" rx="1" fill="#ccc"/>

      {/* Small chart/graph in bottom-right */}
      <polyline points="43,57 48,51 53,54 57,47" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    </svg>
  );
};

export default FigureNewsIcon;
